module.exports = __webpack_public_path__ + "img/art_bottomline.3d462554.png";